export const VIEWBOX = '30.6 38 879.2 560';
export const MAP_RATIO = 879.2 / 560;

export const MAP_ASSETS = {
  plan: '/images/masterplan/map-base.png',
  aerial: '/images/masterplan/map-aerial.jpg',
};

export const TEES = [
  { id: 'noir', label: 'Noir', color: '#1d1f20' },
  { id: 'blanc', label: 'Blanc', color: '#ffffff' },
  { id: 'jaune', label: 'Jaune', color: '#e9c23a' },
  { id: 'bleu', label: 'Bleu', color: '#4da6f0' },
  { id: 'rouge', label: 'Rouge', color: '#c8402a' },
];

export const DISTANCES = {
  noir: [295, 170, 395, 510, 365, 350, 200, 470, 400],
  blanc: [280, 145, 370, 470, 330, 330, 175, 440, 375],
  jaune: [250, 125, 310, 440, 300, 305, 145, 410, 350],
  bleu: [220, 100, 275, 400, 270, 270, 120, 375, 325],
  rouge: [205, 80, 365, 390, 260, 260, 110, 365, 315],
};

export const HOLES = [
  { number: 1, par: 4, hcp: 9, d: 'M55,468 Q170,474 292,431', tee: [55, 468], green: [292, 431], badge: [160, 444] },
  { number: 2, par: 3, hcp: 5, d: 'M248,390 Q190,368 135,331', tee: [248, 390], green: [135, 331], badge: [181, 347] },
  { number: 3, par: 4, hcp: 4, d: 'M120,345 C88,280 82,190 68,99', tee: [120, 345], green: [68, 99], badge: [76, 216] },
  { number: 4, par: 5, hcp: 3, d: 'M150,95 C300,62 430,62 545,82', tee: [150, 95], green: [545, 82], badge: [329, 58] },
  { number: 5, par: 4, hcp: 6, d: 'M575,88 C690,58 800,72 867,126', tee: [575, 88], green: [867, 126], badge: [704, 56] },
  { number: 6, par: 4, hcp: 8, d: 'M880,150 C800,205 700,190 617,129', tee: [880, 150], green: [617, 129], badge: [739, 162] },
  { number: 7, par: 3, hcp: 1, d: 'M530,175 Q612,203 695,186', tee: [530, 175], green: [695, 186], badge: [601, 196] },
  { number: 8, par: 5, hcp: 7, d: 'M610,163 C500,150 350,130 187,134', tee: [610, 163], green: [187, 134], badge: [384, 128] },
  { number: 9, par: 4, hcp: 2, d: 'M143,141 C120,200 155,315 243,365', tee: [143, 141], green: [243, 365], badge: [155, 253] },
];

export const TOTAL_PAR = HOLES.reduce((s, h) => s + h.par, 0);
export const totalFor = (tee) => DISTANCES[tee].reduce((s, v) => s + v, 0);

export const VIEW_THEME = {
  plan: {
    ink: '#1a3c2a', inkOpacity: 0.6, play: '#c9a962',
    markerFill: '#ffffff', markerStroke: '#1a3c2a',
    badgeFill: '#ffffff', badgeText: '#1a3c2a',
  },
  aerial: {
    ink: '#ffffff', inkOpacity: 0.85, play: '#e8d48a',
    markerFill: 'rgba(15,36,25,0.85)', markerStroke: '#ffffff',
    badgeFill: 'rgba(15,36,25,0.85)', badgeText: '#ffffff',
  },
};
